import {
  EventHelpoutEventableTypeEnum,
  EventHelpoutHelpoutableTypeEnum
} from '../_generated/openapi';

export const EventHelpoutEventableType = {
  BASKETBALL_PRACTICE: "App\\Models\\Basketball\\BasketballPractice" as EventHelpoutEventableTypeEnum,
  BASKETBALL_TEAM_GAME:
   "App\\Models\\Basketball\\BasketballTeamGame" as EventHelpoutEventableTypeEnum,
};

export const EventHelpoutHelpoutableType = {
  USER: "App\\Models\\Base\\User"  as EventHelpoutHelpoutableTypeEnum,
  BASKETBALL_TEAM:
  "App\\Models\\Basketball\\BasketballTeam" as EventHelpoutHelpoutableTypeEnum,
};